import React, { Fragment, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import profile01 from "../../../../images/profile/1.jpg";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import ReactPanZoom from "react-image-pan-zoom-rotate";
import PageTitle from "../../../layouts/PageTitle";
import { setNestedObjectValues } from "formik";
import {
  saveoutletDetails,
  getRoleMaster,
  getoutletListMaster,
  gettstaffListMaster,
  resetPWDDetails,
  updatePWDstaffDetails,
  SlotMasterList,
  saveslotmaster,
  updateslotmaster,
} from "../../../../apiservicescall/api";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import Switch from "@material-ui/core/Switch";
import { Col, Badge, Card, Row, Button, Container } from "react-bootstrap";

const SlotMasterManagment = () => {
  const [activeToggle, setActiveToggle] = useState("posts");
  const [sendMessage, setSendMessage] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [cameraModal, setCameraModal] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const [replayModal, setReplayModal] = useState(false);
  const [popUpPageShow, setPopUpPageShow] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [editPageShow, setEditPageShow] = useState();
  const [isView, setIsview] = useState(false);
  const [passwordreset, setPasswordreset] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [addFieldValue, setAddFieldValue] = useState();
  const [errors, setErrors] = useState({
    staffname: null,
    staffmobileno: null,
    // staffemailid: null,
  });
  const [PopupCommonStateTransfer, setPopupCommonStateTransfer] = useState();
  const [role, setRoll] = useState();
  const [staffoutletID, setstaffoutletID] = useState();
  const [staffrole, setStaffrole] = useState([
    { label: "Manager", value: "Manager" },
    { label: "Staff", value: "Staff" },
    { label: "Others", value: "Others" },
  ]);

  const [staffvalue, setStaffvalue] = useState({
    label: "",
    value: "",
  });

  const [isviewoutsid, setIsviewoutsid] = useState(
    JSON.parse(localStorage.getItem("userDetails")).role
  );

  const [selectedOutletvalue, setSelectedOutletvalue] = useState();

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails")).companyCode
  );


  const [admintomanger, setAdmintomanger] = useState(
    JSON.parse(localStorage.getItem("admintomanger"))
  );
  const admintomangerjson = admintomanger && admintomanger.split("-");
  const adminToMangerOutletName = admintomangerjson && admintomangerjson[0].trim();
  const adminToMangerOutletCode = admintomangerjson && admintomangerjson[1].trim();
  const adminToMangerCompanyCode = admintomangerjson && admintomangerjson[2].trim();


  const [staffdetails, setStaffdetails] = useState({
    staffimg: "",
    staffname: "",
    staffID: "",
    staffrole: "",
    staffmobileno: "",
    staffemailid: "",
    compCode: adminToMangerCompanyCode || userDetails?.companyCode,
    staffoutletCode: "",
    staffpassword: "",
    staffConfirmpassword: "",
    activeStatus: true,
    webLogin: true,
    firstLoginStatus: "",
    userId: "",
  });

  const [slotdetails, setSlotdetails] = useState({
    outletCode: "",
    slotId: "",
    endTime: "",
    slotName: "",
    startTime: "",
    status: "",
    slotId: "",
    compCode: "",
  });

  var unixTimestamp = 1651822834;
  var date = new Date(unixTimestamp * 1000);
  const [startTime, handleDateChange] = useState(new Date());
  const [endTime, handleTimeChange] = useState(new Date());
  

  const [slotmaster, setSlotmaster] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [popupModal, setPopupModal] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const [contentModal, setContentModal] = useState(false);
  const [modalCentered, setModalCentered] = useState(false);
  const [modalWithTooltip, setModalWithTooltip] = useState(false);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [largeModal, setLargeModal] = useState(false);
  const [smallModal, setSmallModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());
  const [staffMasterList, setStaffMasterList] = useState([]);

  const [outletvalue, setOutletvalue] = useState({
    label: "",
    value: "",
  });

  const [outlet, setOutlet] = useState([
    { label: "Ekkattuthangal", value: "Ekkattuthangal" },
    { label: "T nagar", value: "T nagar" },
    { label: "Mambalam", value: "Mambalam" },
  ]);
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [outletRolelist, setOutletRolelist] = useState([]);





  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  useEffect(() => {
    let outletCode = adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let companyCode = adminToMangerCompanyCode || loginDetails?.companyCode;

    getslotmaster(outletCode);
    getstaffMasterList();
    getoutletList(companyCode);
    getroleMAsterList();

  }, [popUpPageShow]);

  const getstaffMasterList = async () => {
    let getoutletList = await gettstaffListMaster();
    let getstaffListValue = getoutletList?.data?.data?.userList;
    console.log("getstaffListValue", getstaffListValue);
    setStaffMasterList(getstaffListValue);
  };

  const getslotmaster = async (outletCode) => {
    let getslotList = await SlotMasterList(outletCode);
    let getslotListValue = getslotList?.data?.data;
    setSlotmaster(getslotListValue);
    console.log("getslotListValue", getslotListValue);
  };

  const getoutletList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    let outmaster = getoutletListValue.map(({ outletCode, outletName }) => ({
      label: outletName,
      value: outletCode,
    }));
    console.log("outmaster", outmaster);
    setOutletMasterlist(outmaster);
  };

  const getroleMAsterList = async () => {
    let getoutletList = await getRoleMaster();
    let getoutletListValue = getoutletList?.data?.data;
    let outmaster = getoutletListValue.map(({ roleId, roleName }) => ({
      label: roleName,
      value: roleId,
    }));
    console.log("outmaster", outmaster);
    setOutletRolelist(outmaster);
  };

  const saveslot = async () => {
    let startime24hourshr = new Date(startTime).getHours();
    let startime24hoursmi = new Date(startTime).getMinutes();
    let startTimefinalformat =
      startime24hourshr + ":" + startime24hoursmi + ":" + "00";
    console.log("startTimefinalformat", typeof startTimefinalformat);

    let endtime24hourshr = new Date(endTime).getHours();
    let endime24hoursmi = new Date(endTime).getMinutes();
    let endTimefinalformat =
      endtime24hourshr + ":" + endime24hoursmi + ":" + "00";

    let req = {
      compCode: adminToMangerCompanyCode || userDetails?.companyCode,
      endTime: endTimefinalformat || "",
      startTime: startTimefinalformat || "",
      outletCode: adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode,
      slotId: slotdetails?.slotId,
      slotName: slotdetails?.slotName || "",
      status: "A",
    };

    let reqforupload;

    if (isView === false) {
      reqforupload = await saveslotmaster(req);
    } else {
      reqforupload = await updateslotmaster(req);
    }
    
    if (reqforupload?.status === 200) {

      let outletCode = adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      getslotmaster(outletCode);

      setSlotdetails({});
      setOutletvalue({});
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
      if (isView === false) {
        swal("Success!", "Slot Created", "success");
      } else {
        swal("Success!", "Slot Details Updated", "success");
      }
      // await this.setState({ reload: false });
      // NotificationManager.success("Success");
      // this.setState({ addNewUserModal: false, loading: true });
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
      getstaffMasterList();
    }
  };

  const updatePWDstaff = async () => {
    let compCode = adminToMangerCompanyCode || userDetails?.companyCode;
    let outletCode = [adminToMangerOutletCode || staffdetails?.outletCode[0]?.outletCode];
    let userId = staffdetails?.staffID;

    let reqforupload = await resetPWDDetails(compCode, outletCode, userId);

    if (reqforupload?.status === 200) {
      swal("Success!", "Staff Password Reset Succcesfully", "success");
      setPopUpPageShow(false);
      setLargeModal(false);
      getstaffMasterList();
      setStaffdetails({});
      setStaffvalue({});
      setOutletvalue({});
      setIsview(false);
      setIsedit(false);
      // await this.setState({ reload: false });
      // NotificationManager.success("Success");
      // this.setState({ addNewUserModal: false, loading: true });
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });
      swal("Oops", "Error, Please Try Later", "error");
      setPopUpPageShow(false);
      setLargeModal(false);
      getstaffMasterList();
      setStaffdetails({});
      setStaffvalue({});
      setOutletvalue({});
      setIsview(false);
      setIsedit(false);
    }
  };

  const onChangeCommonpopup = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const stringwithnumberPattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/;
    const mobilePattern = /^[5-9][0-9]{9}$/;
    const emailPattern =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;

    if (key == "slotName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["slotName"] = "Name is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["slotName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["slotName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "staffoutletID") {
      if (!value) {
        addFieldValue = { [value.label]: null };
        errorsLocal["staffoutletID"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        /* setOutletvalue([...value]); */
        setOutletvalue([
          {
            label: value.label,
            value: value.value,
          },
        ]);
        addFieldValue = { ["staffoutletID"]: value.value };
        errorsLocal["staffoutletID"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "role") {
      if (!value) {
        addFieldValue = { [value.label]: null };
        errorsLocal["role"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setStaffvalue({
          label: value.label,
          value: value.value,
        });
        // addFieldValue = { ["role"]: value.value }
        errorsLocal["role"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "webLogin") {
      if (!value) {
        addFieldValue = { [key]: null };
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["webLogin"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    const newFormData = { ...slotdetails };
    newFormData[key] = value;
    setSlotdetails(newFormData);
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "blue" : "black",
  });

  //multiselect//
  const CustomClearText = () => "clear all";
  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };

  //disabled button//
  const isValid = staffdetails;

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    setLargeModal(!largeModal);
    setIsview(false);
    setIsedit(false);
    setSlotdetails({
      staffimg: "",
      staffname: "",
      role: "",
      staffoutletID: "",
      staffmobileno: "",
      staffemailid: "",
      compCode: "",
      outletCode: "",
      slotName: "",
    });
  };

  const onAddUpdateUserModalClose = () => {
    setPopUpPageShow(!popUpPageShow);
  };

  const onEditUser = (data) => {
    let selectedUser = slotmaster.find(
      (value, index) => index === data?.rowIndex
    );
    setSlotdetails({
      slotName: selectedUser.slotName,
      outletCode: adminToMangerOutletCode || selectedUser.outletCode,
      slotId: selectedUser.slotId,
      status: "A",
    });

    // start date update set
    const values = selectedUser?.startTime.split(":");
    console.log("slotmaster?.dayId]", values);
    let dayNameTrimmed = values[0].trim();
    let dayIdTrimmed = values[1].trim();
    var myDate = new Date();
    myDate.setHours(dayNameTrimmed);
    myDate.setMinutes(dayIdTrimmed);
    myDate.setSeconds("00");
    console.log("myDateupdate", myDate);
    handleDateChange(myDate);

    // start date update set
    const endTimevalues = selectedUser?.endTime.split(":");
    console.log("slotmaster?.dayId]", endTimevalues);
    let dayNameTrimmedendTime = endTimevalues[0].trim();
    let dayIdTrimmedendTime = endTimevalues[1].trim();
    var myDateendTime = new Date();
    myDateendTime.setHours(dayNameTrimmedendTime);
    myDateendTime.setMinutes(dayIdTrimmedendTime);
    myDateendTime.setSeconds("00");
    console.log("myDateupdate", myDateendTime);
    handleTimeChange(myDateendTime);

    setLargeModal(true);
    setIsview(true);
    setIsedit(false);
    setPasswordreset(false);

    setFormIsValid(false);
    setErrors({});
  };

  /* const onPasswordResetUser = (data) => {
    let selectedUser = staffMasterList.find(
      (value, index) => index === data?.rowIndex
    );
    setStaffdetails({
      // staffimg: selectedUser.staffid,
      staffname: selectedUser.username,
      role: selectedUser.Admin,
      // staffoutletID: selectedUser.staffid,
      staffmobileno: selectedUser.mobileNo,
      staffemailid: selectedUser.emailId,
      compCode: selectedUser.compCode,
      outletCode: selectedUser.outletCode,
      staffID: selectedUser.userId,
      // staffpassword :
      firstLoginStatus:
        selectedUser.firstLoginStatus == null ||
        selectedUser.firstLoginStatus == "Y"
          ? true
          : false,
      activeStatus:
        selectedUser.activeStatus == null || selectedUser.activeStatus == "A"
          ? true
          : false,
      webLogin:
        selectedUser.webLogin == null || selectedUser.webLogin == "A"
          ? true
          : false,
    });
    // console.log("selectedUser.outletCode", selectedUser.outletCode);
    // console.log("outletRolelist", outletMasterlist);
    const tempstatemaster = selectedUser.outletCode.map(
      ({ outletCode, outletName }) => ({ value: outletCode, label: outletName })
    );
    console.log("tempstatemaster", tempstatemaster);
    setOutletvalue(tempstatemaster);
    // outletCode: selectedUser.outletCode,
    // setLargeModal(true);
    setPopUpPageShow(!popUpPageShow);
    // setIsview(false);
    // setIsedit(false);
    setPasswordreset(true);
  }; */

  const viewUser = (data) => {
    let selectedUser = staffMasterList.find(
      (value, index) => index === data?.rowIndex
    );
    setStaffdetails({
      staffid: selectedUser.staffid,
      staffimg: selectedUser.staffid,
      staffname: selectedUser.staffname,
      mobileno: selectedUser.mobileno,
      emailid: selectedUser.emailid,
      role: selectedUser.role,
    });
    console.log("staffdetails", staffdetails);
    // setstaffMasterList(staffMasterList);
    setLargeModal(true);
    /* setIsview(true); */
    setIsedit(true);
  };

  const onEditModalClose = () => {
    setEditPageShow(false);
  };

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        return (
          <div className="list-action">
            <span style={{ color: "black" }} className="icon-top-left">
              <Link
                className="btn btn-primary shadow btn-xs sharp me-2"
                onClick={() => onEditUser(tableMeta)}
                style={{ background: "#008000" }}
              >
                <i className="fas fa-pencil-alt fa-lg"></i>
              </Link>
            </span>
          </div>
        );
      },
    },
  };

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  const options = {
    filter: false,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    search: false,
    // textLabels: {
    // 	body: {
    // 		noMatch: labelmessage
    // 	},
    // },
    fixedHeader: true,
    tableBodyHeight: "425px",
    fixedSelectColumn: true,
    // page: currentPage,
    pagination: false,
    serverSide: true,
    // rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    // onColumnSortChange: this.customSort,
    onChangePage: (page) => this.changePage(page),
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterVal,
      filterOptions,
      changedColumnIndex,
      displayData
    ) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        this.handleFilterSubmit(newFilters);
      }
    },

    onSearchChange: (searchValue) => this.customSearch(searchValue),
    // table's internal filterList
    confirmFilters: true,

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => this.handleFilterSubmit(applyNewFilters)}
          >
            Apply Filters
          </Button>
        </div>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      //// console.log('onFilterConfirm');
      // console.log('filterList', filterList);
    },

    onFilterDialogOpen: () => {
      //// console.log('filter dialog opened');
    },
    onFilterDialogClose: () => {
      //// console.log('filter dialog closed');
    },
    customToolbar: () => {
      return (
        <>
          <>
            <a
              href="#"
              style={{ backgroundColor: "#008000", color: "white" }}
              onClick={(e) => {
                opnAddNewUserModal(e);
                setSlotdetails({});
                setStaffvalue({});
                setOutletvalue({});
                setErrors({});
              }}
              className="caret btn-sm mr-10"
            >
              Add Slot <i className="zmdi zmdi-lus"></i>
            </a>
          </>
        </>
      );
    },
    // onChangeRowsPerPage: onChangeRowsPerPage,
    // sortOrder: {
    // 	name: sort,
    // 	direction: sortByAscending ? "asc" : "desc",
    // },

    //Search Query for list

    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //   // console.log(searchText);
    //   return (
    // 	<>
    // 	  <CustomSearchRender
    // 		debounceWait={500}
    // 		searchText={searchText}
    // 		onSearch={this.handleSearch}
    // 		onHide={hideSearch}
    // 		options={options}
    // 		onClear={this.handleClear}
    // 		searchField={this.state.searchField}
    // 		searchValue={this.state.searchValue}
    // 		fields={this.state.fields}
    // 		handleFieldChange={this.handleFieldChange}
    // 	  />
    // 	</>
    //   );
    // },
  };

  const columns = [
    // {
    //   name: "slotId",
    //   label: "Slot Id",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",
    //   },
    // },

    {
      name: "slotName",
      label: "Slot Name",
      options: {
        filter: false,
        sort: true,
        // customFilterListOptions: { render: v => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "startTime",
      label: "Start Time",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "endTime",
      label: "End Time",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
        customBodyRender: (status, tableMeta) => {
          return (
            <>
              <div style={{ display: "flex" }}>
                {status != "Active" ? (
                  <span className="badge badge-rounded badge-danger">
                    Active
                  </span>
                ) : (
                  <span className="badge badge-rounded badge-success">
                    Inactive
                  </span>
                )}
              </div>
            </>
          );
        },
      },
    },
    actionOption,
  ];

  return (
    <>
      {largeModal === false ? (
        <>
          <h3 className="me-auto" style={{ fontFamily: "Roboto", color: "darkgreen" }}>
            Slot Master
          </h3>
          <RctCollapsibleCard fullBlock>
            <MuiThemeProvider theme={themeTable}>
              <MUIDataTable
                // title={"Slot Master"}
                data={slotmaster}
                columns={columns}
                isView={isView}
                options={options}
                columOrder={columns}
              />
            </MuiThemeProvider>
          </RctCollapsibleCard>
        </>
      ) : (
        <>
          <RctCollapsibleCard fullBlock>
            <div className="mb-sm-4 d-flex flex-wrap align-items-center text-head">
              <h2 className="mb-3 me-auto" style={{ fontFamily: "Poppins" }}>
                Slot Details
              </h2>
              {largeModal === true && (
                <button
                  className="btn btn-primary btn-rounded me-3 mb-2"
                  onClick={() => {
                    setLargeModal(!largeModal);
                    setIsview(false);
                    setIsedit(false);
                    setPasswordreset(false);
                  }}
                >
                  {" "}
                  Back{" "}
                </button>
              )}
            </div>
            {largeModal === true && (
              <>
                <div className="row">
                  <Col xl="12">
                    <Card>
                      <Card.Header className="text-white bg-secondary  ">
                        <Card.Title style={{ color: "white" }}>
                          {isView === false ? "Create Slot" : "Update Slot"}
                        </Card.Title>
                      </Card.Header>
                      <Card.Body className="mb-0 bg-green-light">
                        <Card.Text style={{ fontSize: "medium" }}>
                          <div className="row">
                            {/* {isviewoutsid == "ADMIN" && (
                              <div class="col-sm col-md-4 form-group">
                                <label
                                  as="a"
                                  variant="badge badge-rounded badge-danger"
                                >
                                  Outlet
                                  <span class="text-warning">*</span>
                                </label>
                                <br />
                                <Select
                                  options={outletMasterlist}
                                   Value={outletvalue}
                                   Value={[outletvalue[0]]}
                                   Value={outletvalue.map((items) => {
                                     
                                     return items.label;
                                   })}
                                  Value={selectedOutletvalue}
                                   isMulti
                                   closeMenuOnSelect={false} 
                                    styles={{
                                  clearIndicator: ClearIndicatorStyles,
                                }}
                                components={{ ClearIndicator }} 
                                  search
                                  name="stateCode"
                                  placeholder="Choose Outlet"
                                  onChange={(event) => {
                                    onChangeCommonpopup("staffoutletID", event);
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            )} */}
                            {/* {isviewoutsid == "ADMIN" && (
                              <div class="col-sm col-md-4 form-group">
                              <label
                                as="a"
                                variant="badge badge-rounded badge-danger"
                              >
                                Outlet
                                <span class="text-warning">*</span>
                              </label>
                              <br />
                              <Select
                                options={outletMasterlist}
                                // Value={outletvalue}
                                // Value={[outletvalue[0]]}
                                // Value={outletvalue.map((items) => {
                                //   
                                //   return items.label;
                                // })}
                                defaultValue={selectedOutletvalue}
                                isMulti
                                closeMenuOnSelect={false}
                                styles={{
                                  clearIndicator: ClearIndicatorStyles,
                                }}
                                components={{ ClearIndicator }}
                                search
                                name="stateCode"
                                placeholder="Choose Outlet"
                                onChange={(event) => {
                                  onChangeCommonpopup("staffoutletID", event);
                                }}
                                autoComplete="off"
                              />
                            </div>
                            )} */}

                            <div class="col-sm col-md-4 form-group">
                              <label
                                as="a"
                                variant="badge badge-rounded badge-danger"
                              >
                                {" "}
                                Slot Name
                                <span class="text-warning">*</span>
                              </label>

                              <br />
                              <Input
                                type="text"
                                name="name"
                                id="name"
                                placeholder="Enter Name"
                                value={slotdetails?.slotName}
                                maxLength="40"
                                required
                                onChange={(e) =>
                                  onChangeCommonpopup(
                                    "slotName",
                                    e.target.value
                                  )
                                }
                                //disabled={isView}
                                autoComplete="off"
                              />
                              <span style={{ color: "red" }}>
                                {errors["staffname"]}
                              </span>
                            </div>

                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <div class="col-sm col-md-4 form-group">
                                <label
                                  as="a"
                                  variant="badge badge-rounded badge-danger"
                                >
                                  {" "}
                                  Start Time
                                  <span class="text-warning">*</span>
                                </label>

                                <div style={{ width: "100px" }}>
                                  <TimePicker
                                    autoOk
                                    placeholder="select starttime"
                                    value={startTime}
                                    /*  onChange={handleDateChange}  */
                                    onChange={(event) => {
                                      
                                      console.log("startTime", startTime);
                                      handleDateChange(event, "date");
                                    }}
                                  />
                                </div>
                              </div>
                              <div class="col-sm col-md-4 form-group">
                                <label
                                  as="a"
                                  variant="badge badge-rounded badge-danger"
                                >
                                  {" "}
                                  End Time
                                  <span class="text-warning">*</span>
                                </label>

                                <div style={{ width: "100px" }}>
                                  <TimePicker
                                    autoOk
                                    placeholder="select endtime"
                                    value={endTime}
                                    onChange={(event) => {
                                      console.log("endTime", endTime);
                                      handleTimeChange(event, "date");
                                    }}
                                  />
                                </div>
                              </div>
                            </MuiPickersUtilsProvider>
                          </div>
                        </Card.Text>
                      </Card.Body>
                      <Card.Footer className="bg-green-light border-0">
                        <div className="row">
                          <div class="col-sm-6 col-md-6 col-lg-8"></div>
                          <div class="col-sm-6 col-md-6 col-lg-4 text-right">
                            {isView === false && isedit === false && (
                              <Button
                                variant="contained"
                                // className="btn-danger text-white me-3 float-right"
                                disabled={!formIsValid}
                                // style={{ backgroundColor: "#f84b6a" }}
                                className={
                                  !formIsValid ? "btn-disabled" : "btn-primary"
                                }
                                onClick={() => {
                                  
                                  /* console.log("finallog", staffdetails) */
                                  console.log("slotdetails", slotdetails);
                                  saveslot();
                                }}
                              >
                                Submit
                              </Button>
                            )}

                            {isView === true && isedit === false && (
                              <Button
                                variant="contained"
                                className="btn-primary text-white me-3 float-left"
                                // className={
                                //   !formIsValid ? "btn-disabled" : "btn-primary"
                                // }
                                onClick={() => {
                                  saveslot()
                                }}
                              // disabled={!formIsValid}
                              >
                                Update
                              </Button>
                            )}

                            <Button
                              variant="contained"
                              onClick={() => {
                                // setStaffdetails({});
                                setSlotdetails({
                                  slotId: "",
                                  endTime: "",
                                  slotName: "",
                                  startTime: "",
                                  status: "",
                                  });
                                setStaffvalue({});
                                setOutletvalue({});
                                setErrors({});
                                }}
                              style={{ marginLeft: "20px" }}
                              className="btn-danger"
                            >
                              Clear
                            </Button>
                          </div>
                        </div>
                      </Card.Footer>
                    </Card>
                  </Col>
                </div>
              </>
            )}
          </RctCollapsibleCard>
        </>
      )}
      {
        <Modal
          isOpen={popUpPageShow}
          toggle={() => onAddUpdateUserModalClose()}
          // size={"lg"}
          //   style={{ maxWidth: "500px" }}
          backdrop="static"
        >
          <ModalHeader onClick={onAddUpdateUserModalClose}>
            RESET PASSWORD
          </ModalHeader>
          <ModalBody>
            {`Are you sure want Reset Password of STAFF ID : ${staffdetails?.staffID} ? `}
          </ModalBody>

          <ModalFooter>
            <Button
              variant="contained"
              onClick={() => {
                // console.log("savestaff", staffdetails);
                updatePWDstaff();
              }}
              className="btn-primary text-white me-3 float-left"
            >
              Reset
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                console.log("savestaff", staffdetails);
                setPopUpPageShow(!popUpPageShow);
              }}
              // style={{ marginLeft: "20px" }}
              className="btn-danger"
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      }
    </>
  );
};
export default SlotMasterManagment;